import { Button } from '@cobliteam/ui/components';

interface OnboardingProps {
  onboarding: {
    totalSteps: number;
    currentStep: number;
    hasOnboarding: boolean;
  };
  resetOnboarding: () => void;
  createOnboarding: () => void;
}

const Onboarding: React.FC<OnboardingProps> = ({ onboarding, resetOnboarding, createOnboarding }) => {
  return (
    <div>
      <h3 className='font-semibold text-lg'>Onboarding</h3>
      {onboarding.hasOnboarding ? (
        <p>
          Etapa {onboarding.currentStep} de {onboarding.totalSteps}
        </p>
      ) : (
        <p>Nenhum onboarding ativo.</p>
      )}

      <div className='mt-4 flex gap-2'>
        <Button onClick={createOnboarding}>Criar</Button>
        <Button variant='outlined' onClick={resetOnboarding}>
          Resetar
        </Button>
      </div>
    </div>
  );
};

export default Onboarding;
